import api from "../../api";
import { setPopUpSuccess } from "../networkError/actions";
import * as types from "./types";

export const setSubs = () => (dispatch) => {
  return api.subscriptions.getSubs().then((res) =>
    dispatch({
      type: types.GET_ALL_SUBSCRIPTIONS,
      subscriptions: res.data,
    })
  );
};

export const getSubscribers = (companyId, insuranceCompanyId, page) => (dispatch) => {
  // Construct params object for the API call
  const apiParams = { 
    id: companyId, 
    ...(page && { numberOfPage: page }), // Add numberOfPage if page is provided
    ...(insuranceCompanyId && { insurance_company_id: insuranceCompanyId }) // Add insurance_company_id if provided
  };
  
  return api.subscriptions.getSubscribers(apiParams).then((res) => {
    dispatch({
      type: types.GET_SUBSCRIPTED_USERS,
      ...res.data,
      // Potentially add current filter info to state if needed elsewhere, e.g., for Paginator to remember
      // currentInsuranceFilter: insuranceCompanyId 
    });
  });
};

export const setSubscribersPagination = ({ id, numberOfPage, insuranceCompanyId }) => (
  dispatch
) => {
  // Construct params object for the API call
  const apiParams = { 
    id, 
    numberOfPage, 
    ...(insuranceCompanyId && { insurance_company_id: insuranceCompanyId })
  };

  return api.subscriptions.getSubscribers(apiParams).then((res) => {
    dispatch({
      type: types.GET_SUBSCRIPTED_USERS,
      ...res.data,
      // currentInsuranceFilter: insuranceCompanyId // Also here if Paginator uses this action
    });
  });
};

export const setPagination = ({ numberOfPage }) => (dispatch) => {
  return api.subscriptions.getSubs(numberOfPage).then((res) => {
    dispatch({
      type: types.GET_ALL_SUBSCRIPTIONS,
      subscriptions: res.data,
    });
  });
};

export const createSub = (body) => {
  return api.subscriptions.createSub(body).then((res) => setSubs());
};

export const deleteSub = (obj) => dispatch => {
  api.subscriptions.deleteSub(obj).then((res) => {
    dispatch({ type: types.DELETE_SUBSCRIBER, id: obj.subscriber })
  })
}

export const deleteCompany = (id) => dispatch => {
  return api.subscriptions.deleteCompany(id)
    .then(() => dispatch({ type: types.DELETE_COMPANY, id }))
}

export const getCompanyDetails = (id) => (dispatch) => {
  return api.subscriptions.getCompany(id).then((res) => {
    console.log("API response in getCompanyDetails action:", res);
    dispatch({
      type: types.GET_COMPANY_DETAILS,
      payload: res,
    });
  });
};
